/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramIndexAvailabilityResponseConflictingProgramInfo } from './ProgramIndexAvailabilityResponseConflictingProgramInfo';
import {
    ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSON,
    ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSONTyped,
    ProgramIndexAvailabilityResponseConflictingProgramInfoToJSON,
} from './ProgramIndexAvailabilityResponseConflictingProgramInfo';

/**
 * 
 * @export
 * @interface ProgramIndexAvailabilityResponse
 */
export interface ProgramIndexAvailabilityResponse {
    /**
     * True if the program index is available or the conflict is with the currentProgramId itself.
     * @type {boolean}
     * @memberof ProgramIndexAvailabilityResponse
     */
    isAvailable: boolean;
    /**
     * 
     * @type {ProgramIndexAvailabilityResponseConflictingProgramInfo}
     * @memberof ProgramIndexAvailabilityResponse
     */
    conflictingProgramInfo?: ProgramIndexAvailabilityResponseConflictingProgramInfo | null;
}

/**
 * Check if a given object implements the ProgramIndexAvailabilityResponse interface.
 */
export function instanceOfProgramIndexAvailabilityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isAvailable" in value;

    return isInstance;
}

export function ProgramIndexAvailabilityResponseFromJSON(json: any): ProgramIndexAvailabilityResponse {
    return ProgramIndexAvailabilityResponseFromJSONTyped(json, false);
}

export function ProgramIndexAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramIndexAvailabilityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAvailable': json['isAvailable'],
        'conflictingProgramInfo': !exists(json, 'conflictingProgramInfo') ? undefined : ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSON(json['conflictingProgramInfo']),
    };
}

export function ProgramIndexAvailabilityResponseToJSON(value?: ProgramIndexAvailabilityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isAvailable': value.isAvailable,
        'conflictingProgramInfo': ProgramIndexAvailabilityResponseConflictingProgramInfoToJSON(value.conflictingProgramInfo),
    };
}

